/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\SeenCar\SeenCarTable\SeenCarRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday December 21st 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Friday, 12th January 2024 06:29:14
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import { memo, useEffect, useState } from "react";
import SeenCarRow, { SeenCarType } from "../SeenCarRow/SeenCarRow";

type SeenCarListProps = {
    seenCar: SeenCarType[],
    displayName: boolean,
    order?: string
};

type UserInfo = {id: string;
    FirstName: string;
    LastName: string;
    Commercial: {
        FirstName: string;
        LastName: string;
    };
    Company: {
        Name: string;
    };
}

type CarInfo = {
    id: string;
    RegNb: string;
    Brand: string;
    Model: string;
    Version: string;
}

type ViewType = {
    user: UserInfo,
    Car: CarInfo,
    lastView: number,
    nbView: number
}

const SeenCarTableMemo = memo(function ConnexionList (props: SeenCarListProps) {
    const [myViews, setMyViews] = useState<ViewType[]>();
    const buildTableHeader = () => {
        let tableHeader = ["Car", "Client", "Commercial", "Date", "Nb"];
        return tableHeader.map(val =>
            <TableCell align="center" key={Math.random()}>{translator.decode(`table.headers.${val}`)}</TableCell>
        );
    };

    // const getNbVue = (input: {[userID: string]: { [regNb: string]: number}[] }, userID: string, carID: string) => {
    //     return input[userID]?.filter(val => Object.keys(val).filter(v => v == carID).length > 0).length ?? 0;
    // }

    // const getLastView = (input: {[userID: string]: { [regNb: string]: number}[] }, userID: string, carID: string) => {
    //     return input[userID]?.filter(val => Object.keys(val).filter(v => v == carID).length > 0).sort().reverse().at(0) ?? 0;
    // }

    const getUserInfo = (userID: string) => {
        const tmp = props.seenCar.filter(v => v.User.id === userID)[0];
        return tmp.User;
    };

    const getCarInfo = (regNb: string) => {
        const tmp = props.seenCar.filter(v => v.Car.RegNb === regNb)[0];
        return {
            id: tmp.Car.id,
            RegNb: tmp.Car.RegNb,
            Brand: tmp.Car.Brand,
            Model: tmp.Car.Model,
            Version: tmp.Car.Version
        };
    };

    useEffect(() => {
        var result: ViewType[] = [];
        var tmp = props.seenCar.map((val)=> {return {UserID: val.User.id, RegNb: val.Car.RegNb, timestamp: new Date(val.Date).getTime() }});
        var tmp2 : { [userID: string]: { [regNb: string]: { lastView: number, nbView: number} } } = {};

        tmp.forEach(val => {
            if (tmp2[val.UserID]) {
                if (tmp2[val.UserID][val.RegNb]) {
                    tmp2[val.UserID][val.RegNb].nbView = ++tmp2[val.UserID][val.RegNb].nbView;
                    tmp2[val.UserID][val.RegNb].lastView = tmp2[val.UserID][val.RegNb].lastView > val.timestamp ? tmp2[val.UserID][val.RegNb].lastView : val.timestamp;
                } else {
                    tmp2[val.UserID][val.RegNb] = {lastView : val.timestamp, nbView: 1};
                    result.push({user: getUserInfo(val.UserID), Car: getCarInfo(val.RegNb), lastView: 0, nbView: 0});
                }
            } else {
                tmp2[val.UserID] = { [val.RegNb]: {lastView : val.timestamp, nbView: 1}};
                result.push({user: getUserInfo(val.UserID), Car: getCarInfo(val.RegNb), lastView: 0, nbView: 0});
            }
        });

        result.forEach((v) => {
            let val = tmp2[v.user.id][v.Car.RegNb];
            v.lastView = val.lastView;
            v.nbView = val.nbView;
        });

        if (props.order && props.order === "asc")
            setMyViews(result.sort((v1, v2) => v1.lastView - v2.lastView));
        else
            setMyViews(result.sort((v1, v2) => v1.lastView - v2.lastView).reverse());

    }, [props.seenCar]);

    return (
        <Paper elevation={4}>
            <Table stickyHeader >
                <TableHead>
                    <TableRow>
                        { buildTableHeader() }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {myViews ? myViews.map((val) => {
                        return <SeenCarRow key={Math.random()}
                        User={{
                            id: val.user.id,
                            FirstName: val.user.FirstName,
                            LastName: val.user.LastName,
                            Commercial: {
                                FirstName: val.user.Commercial?.FirstName,
                                LastName: val.user.Commercial?.LastName
                            },
                            Company:{
                                Name: val.user.Company?.Name
                            }
                        }} Car={{
                            id: val.Car.id,
                            RegNb: val.Car.RegNb,
                            Brand: val.Car.Brand,
                            Model: val.Car.Model,
                            Version: val.Car.Version
                        }} Date={new Date(val.lastView).toString()}
                        NbView={val.nbView}
                        />
                    }) : null}
                </TableBody>
            </Table>
        </Paper>
    )
});

export default SeenCarTableMemo;
